'use strict';
import {AppNavigatorService} from './AppNavigatorService';
import {ChildModelDeletedManager} from './ChildModelDeletedManager';
import {ModelStateCache} from './ModelStateCache';


const angular = require('angular');

module.exports = angular
  .module('app.app-model', [])
  .service('appNavigatorService', AppNavigatorService)
  .service('childModelDeletedManager', ChildModelDeletedManager)
  .service('modelStateCache', ModelStateCache)
;



// WEBPACK FOOTER //
// ./src/js/app-model/index.js